/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  LibCommonRichErrors1,
  LibCommonRichErrors1Interface,
} from "../LibCommonRichErrors1";

const _abi = [
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "selector",
        type: "bytes4",
      },
      {
        internalType: "uint256",
        name: "reentrancyFlags",
        type: "uint256",
      },
    ],
    name: "IllegalReentrancyError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "OnlyCallableBySelfError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

export class LibCommonRichErrors1__factory {
  static readonly abi = _abi;
  static createInterface(): LibCommonRichErrors1Interface {
    return new utils.Interface(_abi) as LibCommonRichErrors1Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): LibCommonRichErrors1 {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as LibCommonRichErrors1;
  }
}
